import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth9deleteDeleteScreenTruthScreensAppIdResponseSchema = jsonObject
export type tcpscreentruth9deleteDeleteScreenTruthScreensAppIdResponse = z.infer<typeof tcpscreentruth9deleteDeleteScreenTruthScreensAppIdResponseSchema>
export const tcpscreentruth9deleteDeleteScreenTruthTargetsAppScreenIdRoleDataStateViewportResponseSchema = jsonObject
export type tcpscreentruth9deleteDeleteScreenTruthTargetsAppScreenIdRoleDataStateViewportResponse = z.infer<typeof tcpscreentruth9deleteDeleteScreenTruthTargetsAppScreenIdRoleDataStateViewportResponseSchema>
